import React from 'react';
import { Card as ReactstrapCard, CardImg, CardBody } from 'reactstrap';
import styles from './Card.module.scss';

const Card = ({ imageSrc, label }) => {
  return (
    <ReactstrapCard className={styles.card}>
      <CardImg top src={imageSrc} alt={label} />
      <CardBody className={styles.label}>
        {label}
      </CardBody>
    </ReactstrapCard>
  );
};

export default Card;
